export default __webpack_public_path__ + "static/media/view_list.1825fb4f.svg";